import { ReactNode, useContext } from "react";
import { Divider, Typography } from "antd";
import { ThemeContext } from "../../../../contexts/ThemeContext";

const { Text } = Typography;

interface IProps {
    title: string;
    icon?: ReactNode;
    subtitle?: string;
    showDivider?: boolean;
}

export default function FieldsGroupTitle({ title, icon, subtitle, showDivider = false }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div style={{ marginTop: showDivider ? 20 : 0, marginBottom: 14 }}>
            {showDivider && (
                <Divider
                    style={{
                        margin: "12px 0 16px 0",
                        borderColor: isDark ? "#262626" : "#f0f0f0",
                    }}
                />
            )}
            <div
                style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: isDark ? "#94a3b8" : "#64748b",
                    textTransform: "uppercase",
                    letterSpacing: "0.4px",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                }}
            >
                {icon}
                <span>{title}</span>
            </div>
            {subtitle && (
                <Text style={{ fontSize: 12, color: isDark ? "#8c8c8c" : "#64748b", marginTop: 2, display: "block" }}>
                    {subtitle}
                </Text>
            )}
        </div>
    );
}